/// <reference path='_all.ts' />


// CHEAT SHEET: http://ivision.com/wp-content/uploads/AngularJS_v2.pdf

/**
 * The main TodoMVC app module.
 *
 * @type {angular.Module}
 */
module shoppinglist {
  'use strict';

  var shoppinglist = angular.module('shoppinglist', ['LocalStorageModule', 'navigation', 'ngAnimate', 'ngMaterial', 'ngMessages', 'ngLocale'])    
    .config(['localStorageServiceProvider', function(localStorageServiceProvider){ 
      localStorageServiceProvider.setPrefix('com.photometer');
    }])
    .controller('ShoppingListCtrl', ShoppingListCtrl)
    .controller('ShareModalCtrl', ShareModalCtrl)
    .controller('ShoppingListViewCtrl', ShoppingListViewCtrl)
    .directive('availability', AvailabilityDirective)
    .directive('shoppingListTable', ShoppingListTableDirective)
    .directive('selectOnClick', selectOnClickDirective)
    .directive('addToCartButton', AddToCartButtonDirective)
    .filter('ofnumber', OfNumber) 
    .service('shoppingListService', ShoppingListService); 
}  


